// extracted by mini-css-extract-plugin
module.exports = {"Truncate":"Truncate__2iZb5","Truncate--breakAll":"Truncate--breakAll__Mn3Mt","Truncate--keepAll":"Truncate--keepAll__3Hhnq","Truncate--breakWord":"Truncate--breakWord__1cNFJ"};